import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'

import Profile from 'components/profile'
import { shouldHideDossierSelector } from 'selectors/profile'
import { useProfile } from 'components/use_profile'
import _Description from "dossier-Description.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/dossier.js?styleId=Description";
import _Block from "dossier-Block.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_event_type/dossier.js?styleId=Block";


const Description = /*#__PURE__*/styled('div', null, {
  displayName: "Description",
  styles: _Description
})

const Block = /*#__PURE__*/styled('div', null, {
  displayName: "Block",
  styles: _Block
})

export default function Dossier() {
  const shouldHideDossier = useSelector(shouldHideDossierSelector)
  const profile = useProfile()

  if (!profile) return null

  const {
    avatar_url: avatarUrl,
    logo_url: logoUrl,
    name,
    description
  } = profile

  if (shouldHideDossier) { return <VisuallyHidden><h1>{name}</h1></VisuallyHidden> }

  return (
    <Block data-id="dossier">
      <Profile
        avatar={avatarUrl}
        name={name}
        logoUrl={logoUrl}
      />
      <Description>
        {description}
      </Description>
    </Block>
  )
}
